import { OuiSelectOption } from 'omnium-ui/form-field';
import { Observable } from 'rxjs';
import { fullComparator, inOperator } from '../../filtre-investisseur-helper';
import { FiltreBuilder, ItemFiltreCustomBuilder } from '../filtre-builder.model';

export function getProfessionnelBuilders(cspTopOptions$: Observable<OuiSelectOption[] | null>): FiltreBuilder[] {
  return [
    new ItemFiltreCustomBuilder(
      'PROFESSIONNEL',
      'PROFESSION_CSP',
      'atlasInvestisseur.investisseurPersonnePhysiques.some.personnePhysique.situationProfessionnelle.categorieSocioProfessionnelleCodeAtlasNavigation.parent',
      inOperator,
      'SelectMultiple',
      cspTopOptions$
    ),
    new ItemFiltreCustomBuilder(
      'PROFESSIONNEL',
      'PROFESSION_DATE_DEPART_RETRAITE',
      'atlasInvestisseur.investisseurPersonnePhysiques.some.personnePhysique.situationProfessionnelle.dateDepartRetraite',
      fullComparator,
      'Date'
    ),
  ];
}
